import React from 'react'
import { AdSlot, DFPSlotsProvider } from 'react-dfp'
import styled from 'styled-components'

import mq from '../../utils/mediaQuery'

const Ads = styled.div`
  pointer-events: auto;
  padding: 40px 0 20px;
  text-align: center;
  ${mq.tablet} {
    padding-top: 12px;
  }
  ${mq.mobile} {
    padding-top: 12px;
  }
  > div {
    margin-left: auto;
    margin-right: auto;
  }
`

const ProjectAds = React.memo(() => (
  <Ads>
    <DFPSlotsProvider
      dfpNetworkId={process.env.DFP_NETWORK_ID}
      collapseEmtpyDivs
    >
      <AdSlot adUnit={process.env.AD_UNIT_DETAIL} sizes={[[300, 250]]} />
    </DFPSlotsProvider>
  </Ads>
))

export default ProjectAds
